import React, { useRef, useEffect } from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box, Image } from 'components/ui';
import { radii, space } from 'style/config';
import IncentivizedBadge from 'components/ProductPage/IncentivizedBadge/IncentivizedBadge';
import localeUtils from 'utils/LanguageLocale';
import ReviewsImageCarouselEN from 'components/ProductPage/ReviewsImageCarousel/locales/ReviewsImageCarousel_en_US';
import ReviewsImageCarouselFR from 'components/ProductPage/ReviewsImageCarousel/locales/ReviewsImageCarousel_fr_CA';

const getText = localeUtils.getLocalisedDataFromResource(ReviewsImageCarouselEN, ReviewsImageCarouselFR);

const CARD_TRANSITION_OFFSET = space[1];

const RatingImageCard = ({
    imgSrc, onClickAction, isIncentivizedReview, isObserved, updateVisibleItems
}) => {
    const ref = useRef(null);

    useEffect(() => {
        if (!isObserved) {
            return undefined;
        }

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                updateVisibleItems();
                observer.disconnect();
            }
        });

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => observer.disconnect();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <button
            aria-label={getText('showReview')}
            css={styles.button}
            data-at={Sephora.debug.dataAt('rating_image_section')}
            onClick={onClickAction}
            ref={ref}
        >
            <Image
                src={imgSrc}
                size='100%'
                borderRadius={2}
                css={styles.image}
            />
            {isIncentivizedReview && (
                <Box
                    position='absolute'
                    right={2}
                    bottom={2}
                >
                    <IncentivizedBadge
                        tooltipProps={{
                            side: 'top',
                            isFixed: true,
                            stopPropagation: true
                        }}
                        isOverlay={true}
                    />
                </Box>
            )}
        </button>
    );
};

const styles = {
    button: {
        borderRadius: radii[2],
        overflow: 'hidden',
        width: '100%',
        position: 'relative',
        paddingBottom: '100%',
        marginTop: CARD_TRANSITION_OFFSET,
        transition: 'transform .2s',
        '.no-touch &': {
            willChange: 'transform'
        },
        '.no-touch &:hover, :focus': {
            transform: `translateY(-${CARD_TRANSITION_OFFSET}px)`
        }
    },
    image: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover'
    }
};

export default wrapFunctionalComponent(RatingImageCard, 'RatingImageCard');
